import React from "react";
import { Search } from "@mui/icons-material";
import {
  Checkbox,
  FormControl,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  TextField,
} from "@mui/material";
import { Tags } from ".";
import isObject from "helpers/isObject";

const uniqueArray = (arr) =>
  arr.filter((value, index) => {
    const _value = JSON.stringify(value);
    return index === arr.findIndex((obj) => JSON.stringify(obj) === _value);
  });

const SelectTags = ({ data, limit, selected, onChange, error }) => {
  const [q, setSearch] = React.useState("");
  const Limit = limit || 5;
  const vCrops = selected || [];

  const qCrops = q
    ? data.filter((c) =>
        c
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase()
          .includes(q.toLowerCase())
      )
    : data;

  const includesObj = (tag) => {
    return vCrops.filter((t) => t.value === tag.value).length > 0;
  };

  const handleToggle = (value) => {
    if (isObject(value)) {
      let newTags = [...vCrops];
      if (includesObj(value)) {
        const currentIndex = newTags.findIndex(
          (obj) => JSON.stringify(obj) === JSON.stringify(value)
        );

        newTags.splice(currentIndex, 1);
      } else {
        newTags = uniqueArray([value, ...vCrops]);
      }
      onChange(newTags);
    } else {
      const exists = vCrops.includes(value);
      let newChecked = [...vCrops];

      if (exists) {
        newChecked = vCrops.filter((c) => c !== value);
      } else {
        newChecked.push(value);
      }

      onChange(newChecked);
    }
  };

  return (
    <React.Fragment>
      <div>
        <div className="mb-1">
          <small>Sélectionner un ou plusieurs cultures</small>
        </div>
        {vCrops.length > 0 && (
          <Tags tags={vCrops} onRemove={(tag) => handleToggle(tag)} />
        )}

        <FormControl fullWidth>
          <TextField
            placeholder="Rechercher un culture"
            className="zws mt-1"
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{
              endAdornment: <Search style={{ height: 15 }} />,
            }}
            error={Boolean(error)}
            helperText={error}
          />
        </FormControl>

        <List sx={{ width: "100%", maxHeight: 245, overflowX: "scroll" }}>
          {qCrops &&
            qCrops.map((value, index) => (
              <ListItem
                key={index}
                disablePadding
                className="border mb-1"
                onClick={() => handleToggle(value)}
                secondaryAction={
                  <Checkbox
                    edge="end"
                    disabled={
                      vCrops.length === Limit &&
                      !vCrops.includes(isObject(value) ? value.value : value)
                    }
                    onChange={() => handleToggle(value)}
                    checked={
                      isObject(value)
                        ? includesObj(value)
                        : vCrops.includes(value)
                    }
                  />
                }
              >
                <ListItemButton>
                  <ListItemText
                    primary={isObject(value) ? value.name : value}
                  />
                </ListItemButton>
              </ListItem>
            ))}
        </List>
      </div>
    </React.Fragment>
  );
};

export default SelectTags;
